<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-card-text>
      <v-flex>
        <v-select
          label="Папки"
          v-model="itemId"
          hint="Структура папок видна только для пользователей депонента"
          :items="getDisplayPaths()"
          item-value="key"
          item-text="value"
        >
        </v-select>
      </v-flex>
    </v-card-text>
    <template #actions>
      <v-btn @click="ok">ОК</v-btn>
    </template>  
  </v-btn-form>  
</template>

<script type="text/javascript">
  // import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'folder-selector',
    components: {vBtnForm},
    data: () => ({
      itemId: null
    }),
    props: {
      toolbar: {
        type: Boolean,
        default: false
      },
      path: {
        type: String,
        default: '/'
      }
    },
    created () {
      if (this.getProfileHaveClient) {
        this.$store.dispatch('fetchDepoFolders')
      }
    },
    mounted () {
      this.itemId = this.path
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient',
        getDepoDisplayPaths: 'getDepoDisplayPaths'
      }),
      title () {
        return 'Выберите папку'
      }
    },
    methods: {
      ok () {
        this.$emit('input', this.itemId)
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      getDisplayPaths () {
        var map = this.getDepoDisplayPaths
        var result = []
        if (!map) {
          return result
        }
        map.forEach((val, key) => result.push({key: key, value: val}))
        return result.sort((a, b) => formats.compareString(a.value, b.value))
      }
    }

  }

</script>




// WEBPACK FOOTER //
// FolderSelector.vue?6c47f5f1